import $ from 'jquery';

export const init = () => {
	const initInvoice = () => {
		const jsInvoice = $('.js-tabs-content.is-active .js-invoice');
		jsInvoice.find('[data-invoice]').on('click', (e) => {
			const anchor = $(e.target).data('invoice');
			const anchorElem = jsInvoice.find(`#${anchor} button`);

			if (!anchorElem.hasClass('is-open')) anchorElem.click();
			window.scrollTo(0, anchorElem.offset().top, { behavior: 'smooth' });
		});
	};

	initInvoice();

	const jsTabs = $('.js-tabs-link');
	jsTabs.click(() => setTimeout(initInvoice));
};
